import React from "react";
import { useRouter } from "next/router";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { Hooks } from "@xt/xtbase";
import { get_tdk } from "api/server/tdk";
import { Util } from "@xt/xtbase";
import ConvertHistory from "components/Pages/Convert/ConvertHistory";

const { useTranslation } = Hooks;
const { getOrigin } = Util;

export default function ConvertHistoryPage(props) {
  const t = useTranslation();
  const router = useRouter();

  const handleBack = () => {
    router.back();
  };

  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      {/* 使用带返回的 Header：左侧返回箭头 + 标题「交易记录」 */}
      <BackHeader title={t("convert.transactionHistory")} onBack={handleBack} />
      <div style={{ paddingTop: "calc(44px + env(safe-area-inset-top, 0px))" }}>
        <ConvertHistory />
      </div>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const resolvedUrl = "/convert/history";
  const props = { resolvedUrl };
  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      }
    });
    props.tdk = tdk || {};
  } catch (error) {
    props.tdk = {};
  }
  return {
    props,
    revalidate: 60
  };
}
